// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__Zi9OP","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2OQ1C"};